import moment from "moment";
import { entity } from "../rpc/api";
import MessageRoomList = entity.MessageRoomList;

class MessageRoomConvertResponse {
  public static from(from: entity.MessageRoom): MessageRoomConvertResponse {
    // Backend => FrontEnd における型変換
    const createdAtDate: Date = MessageRoomConvertResponse.convertToDate(
      from.createdAt
    );
    const updatedAtDate: Date = MessageRoomConvertResponse.convertToDate(
      from.updatedAt
    );

    return new MessageRoomConvertResponse(
      from.id,
      from.projectID,
      from.customerID,
      from.companyID,
      from.customerUnRead,
      from.customerUnReadCount,
      from.companyUnRead,
      from.companyUnReadCount,
      from.isScout,
      from.hasContract,
      createdAtDate,
      updatedAtDate
    );
  }

  // Backend => FrontEnd における型変換　日付があればDate変換　なければ今日のDateを入れる
  private static convertToDate = (dateString: string): Date => {
    return dateString
      ? moment(dateString, "YYYY-MM-DD HH:II:SS").toDate()
      : moment().toDate();
  };

  constructor(
    public readonly id: string,
    public readonly projectID: string,
    public readonly customerID: string,
    public readonly companyID: string,
    public readonly customerUnRead: boolean,
    public readonly customerUnReadCount: number | Long,
    public readonly companyUnRead: boolean,
    public readonly companyUnReadCount: number | Long,
    public readonly isScout: boolean,
    public readonly hasContract: boolean,
    public readonly createdAt: Date,
    public readonly updatedAt: Date
  ) {}
}

class MessageRoomConvertResponseList {
  public static from(from: MessageRoomList): MessageRoomConvertResponseList {
    const items: MessageRoomConvertResponse[] = [];

    from.items.map((item, index) => {
      return items.push(
        MessageRoomConvertResponse.from(item as entity.MessageRoom)
      );
    });

    return new MessageRoomConvertResponseList(items);
  }

  constructor(public readonly items: MessageRoomConvertResponse[]) {}
}

export { MessageRoomConvertResponse, MessageRoomConvertResponseList };



// WEBPACK FOOTER //
// ./src/infra/api/service/message_room_api_convert.ts